const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "今年最后一次jam活动，BOOOMxUnity开发者社区游戏创作活动来了！"
const desc = "新增赛道、新增奖项，超大规模！"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  links: {
    submitGuide: "https://developer.unity.cn/projects/64f049cbedbc2a001c0aeaf4",
    unityQQ: "https://pd.qq.com/s/ele2u5qyx",
    jiheGameSubmitGuide: "https://www.gcores.com/articles/171955",
    enroll: "https://form.cloud.custouch.com/show/1128968187744890880",
    hezuo: "https://www.gcores.com/topics/522",
    zhaomu: "https://www.gcores.com/topics/521",

    g4g: "https://www.g4g.cn/",
    unity: "https://developer.unity.cn/",
    kaituo: "https://www.coreblazer.com/",
  },
}
